"use client"

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/auth-context'
import { useLanguage } from '@/contexts/language-context'
import { ArrowRight } from 'lucide-react'
import { LoginModal } from '@/components/auth/login-modal'

interface GetStartedButtonProps {
  size?: 'default' | 'sm' | 'lg' | 'icon'
  variant?: 'default' | 'outline' | 'secondary' | 'ghost'
  className?: string
  labelKey?: string
}

// 通用 Get Started 按钮（未登录弹窗，已登录隐藏）
export function GetStartedButton({ size='lg', variant='default', className='', labelKey='hero.cta.getStarted' }: GetStartedButtonProps) {
  const { isAuthenticated } = useAuth()
  const { t } = useLanguage()
  const [open, setOpen] = useState(false)

  if (isAuthenticated) return null

  return (
    <>
      <Button size={size} variant={variant} className={className} onClick={() => setOpen(true)}>
        {t(labelKey) || t('hero.cta.getStarted') || 'Get Started Free'} <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
      <LoginModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  )
}
